import { useEffect } from 'react';

import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';
import { isCanonicalUser } from 'core/helpers/troubleshooting-mode';

/**
 * Runs the member and offer match searches for the offer in the store, so the header can show
 * whether the applicant matches an existing member. Shared by today's offer header and the Staff
 * Quote Revisit header.
 */
const useMemberMatchSearch = () => {
  const session = useSession();
  // Derive the boolean here (not inside the effect) and depend on it: AuthContext's value is a
  // fresh object each render, so depending on `session` would re-fire the search spuriously.
  const excludeTroubleshootingOffers = isCanonicalUser(session);

  const {
    offer: { loading, offer },
    matchSearch
  } = useStore();

  useEffect(() => {
    // Set initial search string only when modal opens and search is empty
    if (offer && !loading && !matchSearch.loading && !matchSearch.searchString) {
      let expectedSearchString;

      if (offer.quote?.existingCustomer?.id) {
        expectedSearchString = offer.quote.existingCustomer.id;
      } else if (offer.quote?.fname && offer.quote?.lname) {
        const offerState = offer?.state || offer?.quote?.correctedAddress?.state || offer?.quote?.address?.state || '';
        const state = offerState ? ` ${offerState}` : '';
        expectedSearchString = `${offer.quote.fname} ${offer.quote.lname}${state}`;
      }

      if (expectedSearchString) {
        matchSearch.setCurrentResultsPage(0);
        matchSearch.setSearchString(expectedSearchString);
        matchSearch.searchCustomersAction();
        matchSearch.searchOffersAction({ excludeTroubleshootingOffers });
      }
    }
  }, [
    matchSearch.searchCustomersAction,
    matchSearch.searchString,
    loading,
    matchSearch.loading,
    offer?.quote?.existingCustomer?.id,
    excludeTroubleshootingOffers
  ]);

  useEffect(() => {
    // Reset search string when offer changes
    matchSearch.setSearchString('');
  }, [offer?.offer?.id]);
};

export default useMemberMatchSearch;
